import React, { useCallback, useEffect, useState } from 'react';
import { Button, Row } from 'reactstrap';
import { Option, StyleOption } from '../../styled';
import DefaultModal from '../../../../../../../components/Modal/DefaultModal';
import { HiUserAdd } from 'react-icons/hi';
import LeadInputs from 'views/CRM/Lead/form/FormInputs';
import OpportunityInputs from 'views/CRM/Opportunity/form/FormInputs';
import { useRecordTypesByUser } from 'views/RecordType/hooks/useRecordTypesByUser';
import { entitiesName } from 'views/CRM/shared/utils/entitiesName';
import ReactLoader from 'components/Loader';
import RecordTypeSelection from 'views/RecordType/components/RecordTypeSelection';

export const ModalLeadOpportunity = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [shouldShowLeadForm, setShouldShowLeadForm] = useState(false);
  const [shouldShowOpportunityForm, setShouldShowOpportunityForm] =
    useState(false);
  const [selectedRecordTypeId, setSelectedRecordTypeId] = useState(null);
  const [formType, setFormType] = useState(null);

  const { recordTypes, isLoadingRecordTypes, getRecordTypesByUser } =
    useRecordTypesByUser(
      formType === 'lead' ? entitiesName.LEAD : entitiesName.OPPORTUNITY
    );

  useEffect(() => {
    if (isModalOpen) {
      getRecordTypesByUser();
      return;
    }
    setShouldShowLeadForm(false);
    setShouldShowOpportunityForm(false);
  }, [isModalOpen, getRecordTypesByUser]);

  useEffect(() => {
    if (recordTypes && recordTypes.length > 0) {
      setSelectedRecordTypeId(recordTypes[0].id);
    }
  }, [recordTypes]);

  const handleOnSelectedRecordType = useCallback(
    (recordTypeId) => {
      setSelectedRecordTypeId(recordTypeId);
      if (formType === 'lead') {
        setShouldShowLeadForm(true);
        setShouldShowOpportunityForm(false);
      } else if (formType === 'opportunity') {
        setShouldShowOpportunityForm(true);
        setShouldShowLeadForm(false);
      }
    },
    [formType]
  );

  const shouldShowRecordTypeSelection =
    isLoadingRecordTypes || (!shouldShowLeadForm && !shouldShowOpportunityForm);

  return (
    <>
      <Option title={'Criar Lead/Oportunidade'}>
        <Button
          color="link"
          size="sm"
          style={StyleOption}
          onClick={() => setIsModalOpen(true)}
        >
          <HiUserAdd size={20} color="#32325d" />
        </Button>
      </Option>

      <DefaultModal
        show={isModalOpen}
        onModalToggle={setIsModalOpen}
        title={`Adicionar ${formType === 'lead' ? 'Lead' : 'Oportunidade'}`}
        showCloseButton={false}
        modalContainerClasses="modal-lg"
      >
        <Row
          className="justify-content-md-center"
          style={{ marginBottom: '20px' }}
        >
          {!shouldShowLeadForm && !shouldShowOpportunityForm && (
            <>
              <Button
                color="primary"
                onClick={() => setFormType('lead')}
                disabled={formType === 'lead'}
              >
                Criar Lead
              </Button>
              <Button
                color="primary"
                onClick={() => setFormType('opportunity')}
                disabled={formType === 'opportunity'}
              >
                Criar Oportunidade
              </Button>
            </>
          )}
        </Row>

        {isLoadingRecordTypes || !selectedRecordTypeId ? (
          <Row className="justify-content-md-center">
            <ReactLoader />
          </Row>
        ) : (
          <>
            {shouldShowRecordTypeSelection && formType ? (
              <RecordTypeSelection
                recordTypes={recordTypes}
                handleOnSelectedRecordType={handleOnSelectedRecordType}
              />
            ) : (
              <>
                {formType === 'lead' && (
                  <LeadInputs
                    recordTypeId={selectedRecordTypeId}
                    isModal={true}
                    callbackFunc={() => setIsModalOpen(false)}
                  />
                )}
                {formType === 'opportunity' && (
                  <OpportunityInputs
                    recordTypeId={selectedRecordTypeId}
                    isModal={true}
                    callbackFunc={() => setIsModalOpen(false)}
                  />
                )}
              </>
            )}
          </>
        )}
      </DefaultModal>
    </>
  );
};
